<template>
  <div class="main-container" >
    <div v-if="loading" class="loadingDiv">
      <div class="loading"></div>
      <p>⏳ {{loadingMessage}}</p>
    </div>
    <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
    <div v-if="ifEmployee && !loading">
      <tl-header type="h1">Income Tax Declaration</tl-header>
      <div class="bg-gray" v-if="!itEnableValue">
          <img class="warning-img" src="@/assets/warning.svg" alt />
          <span class="investment-alert-message">Income Tax Declaration window is not enabled for the Month.</span>
      </div>

      <div class="margintop-16" />
      <div class="income-tax-summary-box">
        <div class="income-tax-text">Income Tax Summary</div>
        <div class="headingContainer">
          <div class="headingLeftContainer">
              <div v-if="!removeRegimeChange || (removeRegimeChange && (financial_year_month == 'Apr' || financial_year_month == 'apr'))" class="custom-col-3">
                <div class="sm-text-it-summary">Select Regime</div>
                <div class="radioButton" >
                  <tl-radio class="no-wrap-label" name="Variable" id="oldRegime" value="Old Regime" v-on:change="(val)=>setRegimeFromRadio(val)" v-model="employeeRegimeType" label="Old Regime"/>
                  <tl-radio class="no-wrap-label" name="Variable" id="newRegime" value="New Regime" v-on:change="(val)=>setRegimeFromRadio(val)" v-model="employeeRegimeType" label="New Regime"/>
                </div>
              </div>
              <span class="sm-text-it-summary" style="margin-left:10px;" v-if="removeRegimeChange && financial_year_month.toLowerCase() !== 'apr'"> Selected Regime : <span style="font-weight:bolder;">{{employeeRegimeType}}</span></span>
              <!-- <div class="custom-col-3">
                <div class="sm-text-it-summary">Net Taxable Income</div>
                <div class="sm-sub-text-it-summary">₹{{ netTaxableIncome }}</div>
              </div>
              <div class="custom-col-3">
                <div class="sm-text-it-summary">Total Tax</div>
                <div class="sm-sub-text-it-summary">₹{{ totalTax }}</div>
              </div>
              <div class="custom-col-3">
                <div class="sm-text-it-summary">Tax to be paid this month</div>
                <div class="sm-sub-text-it-summary">₹{{ taxToPaid }}<span class="sm-sub-text-right"></span></div>
              </div> -->
            </div>
          <div class="headingRightContainer">
            <div class="change-btn-color-text" @click="taxCompareFunction">Compare Tax</div>
            <!-- <div class="back-btn-color-text">Back</div> -->
          </div>
        </div>
      </div>
      <div> 
      <div  class="twoColumnGridDashboard   marginContainer">
        <div class="declarationContainer" v-if="employeeRegimeType == 'Old Regime'" @click="showPopupExemptionUnderSectionDeduction = !showPopupExemptionUnderSectionDeduction">
              <div class="">
                <img src="@/assets/home_rent_declartion.svg"/>
              </div>
              <div class=""> 
                <p class="heading-text">House Rent Declaration</p>
                <span class="sub-heading-details-sm">
                  To claim House rent allowance(HRA), it is necessary to
                  provide evidence of the payment of the rent to the employee.
                </span>
                <p  class="total-amount-text">Total Amount: ₹{{ hraExemptionAmount.toLocaleString("en-in") }}</p>
              </div>
              <div class="arrow-left-align">
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
              </div>
          </div>
        <pop-up-window-lg
                v-if="showPopupExemptionUnderSectionDeduction"
                @back="changeHeaderTitle"
                :header="exemptionSection"
                >
                <template v-slot:content>
                   <hra-exemption-popup @passPopupHeader="popupMessage"
                    @back="showPopupExemptionUnderSectionDeduction = !showPopupExemptionUnderSectionDeduction"
                    :saveAsDraft="saveAsDraft"
                    :HraFormData="data2.exemption10"
                    @hraExemption="hraExemptionFun"
                    :itEnableValue = "itEnableValue"
                    >
                  </hra-exemption-popup>
                </template>
          </pop-up-window-lg>

          <div class="declarationContainer" v-if="employeeRegimeType == 'Old Regime' || (employeeRegimeType == 'New Regime' && enableSection10ForNewRegime)" @click="showPopupExemptionUnderSection10Deduction = !showPopupExemptionUnderSection10Deduction">
              <div class="">
                <img src="@/assets/home_rent_declartion.svg"/>
              </div>
              <div class=""> 
                <p class="heading-text">Section 10 Exemption</p>
                <span class="sub-heading-details-sm">
                  To claim other section 10 exemptions other than house rent allowance(HRA).
                </span>
                <p  class="total-amount-text">Total Amount: ₹{{ section10ExemptionAmount.toLocaleString("en-in") }}</p>
              </div>
              <div class="arrow-left-align">
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
              </div>
          </div>
        <pop-up-window-lg
                v-if="showPopupExemptionUnderSection10Deduction"
                @back="showPopupExemptionUnderSection10Deduction = !showPopupExemptionUnderSection10Deduction"
                header="Section 10 Exemption"
                >
                <template v-slot:content>
                   <section-ten-exemption @passPopupHeader="popupMessage"
                    @back="showPopupExemptionUnderSection10Deduction = !showPopupExemptionUnderSection10Deduction"
                    :saveAsDraft="saveAsDraft"
                    :itEnableValue = "itEnableValue"
                    :HraFormData="data2.exemption10"
                    @section10Exemption="section10ExemptionFun"
                    >
                  </section-ten-exemption>
                </template>
          </pop-up-window-lg>

          <div class="declarationContainer" @click="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu">
              <div class="">
                <img src="@/assets/deduction_under_80CD.svg"/>
              </div>
              <div class=""> 
                <p class="heading-text">Deduction Under Chapter VI A</p>
                <span class="sub-heading-details-sm">
                  Section 80C offers tax deductions on different types of 
                  tax-saving investments, such as ULIP,PPF, premium, etc.
                </span>
                <p  class="total-amount-text">Total Amount: ₹{{ chapterVIATotalAmount.toLocaleString("en-in")}}</p>
              </div>
              <div class="arrow-left-align">
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
              </div>
          </div>

        <pop-up-window-lg
              v-if="showPopupDeductionUnderCdeu"
              @back="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu"
              header="Deduction Under Chapter VI A"
              >
                <template v-slot:content>
                  <less-deduction-under-chapter-VIA-popup 
                  @back="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu"
                  :regimeType = "employeeRegimeType"
                  :saveAsDraft="saveAsDraft"
                  :itEnableValue = "itEnableValue"
                  :ChapterVIA="data2.deductionsUnderChapterVIA"
                  @chapterVIA="chapterVIA"
                  >
                  </less-deduction-under-chapter-VIA-popup>
              </template>
        </pop-up-window-lg>
            <div class="declarationContainer" @click="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty">
              <div class="">
                <img src="@/assets/incomeLossFromHousingProperty.svg"/>
              </div>
              <div class=""> 
                <p class="heading-text">Income/Loss from Housing Property</p>
                <span class="sub-heading-details-sm">
                  A taxpayer can claim deduction under Section 24 of interest paid 
                  on home loan for each of the houses separately.
                </span>
                <p  class="total-amount-text">Total Amount: ₹{{ section24TotalAmount.toLocaleString("en-in") }}</p>
              </div>
              <div class="arrow-left-align">
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
              </div>
          </div>
          <pop-up-window-lg
                v-if="showPopupIncomeLossFromHousingProperty"
                @back="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty"
                header="Section 24A"
                >
                  <template v-slot:content>
                    <income-loss-from-house-property-popup
                    @back="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty"
                    :saveAsDraft="saveAsDraft"
                    :itEnableValue = "itEnableValue"
                          :Section24="data2.section24"
                          :regimeType="employeeRegimeType"
                          @incomeLossFromHousingProperty="incomeLossFromHousingProperty"
                    >
                    </income-loss-from-house-property-popup>
                </template>
          </pop-up-window-lg>

          <div v-if="isFirstMonth" class="declarationContainer" @click="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer">
              <div class="">
                <img src="@/assets/incomeFromPreviousEmployer.svg"/>
              </div>
              <div class=""> 
                <p class="heading-text">Income from Previous Employer</p>
                <span class="sub-heading-details-sm">
                  It's not mandatory that you should report your previous
                  employer salary income and TDS amount deducted.
                </span>
                <p  class="total-amount-text">Total Amount: ₹{{ previousEmployerAmount.toLocaleString("en-in") }}</p>
              </div>
              <div class="arrow-left-align">
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
              </div>
          </div>
          <pop-up-window-lg
                v-if="showPopupIncomeFromPreviousEmployer"
                @back="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer"
              
                header="Income From Previous Employer"
              
                >
                  <template v-slot:content>
                    <income-from-previous-employer 
                    @back="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer"
                    :saveAsDraft="saveAsDraft"
                    :itEnableValue = "itEnableValue"
                    :previousEmploymentDetails="data2.previousEmploymentDetails"
                    @previousDataUpdate="previousDataUpdate"
                    >
                    </income-from-previous-employer>
                </template>
            </pop-up-window-lg>
            <div class="declarationContainer" @click="showPopupOtherIncome = !showPopupOtherIncome">
              <div class="">
                <img src="@/assets/other_income.svg"/>
              </div>
              <div class=""> 
                <p class="heading-text">Other Income</p>
                <span class="sub-heading-details-sm">
                  Other income is income that does not come from a company's
                  main business, such as interest.
                </span>
                <p  class="total-amount-text">Total Amount: ₹{{ otherIncomeAmount.toLocaleString("en-in") }}</p>
              </div>
              <div class="arrow-left-align">
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
              </div>
          </div>
          <pop-up-window-lg
                v-if="showPopupOtherIncome"
                @back="showPopupOtherIncome = !showPopupOtherIncome"
                header="Other Income"
                >
                  <template v-slot:content>
                    <income-from-other-sources-popup
                    @back="showPopupOtherIncome = !showPopupOtherIncome"
                    :saveAsDraft="saveAsDraft"
                    :itEnableValue = "itEnableValue"
                    :IncomeOtherSource="data2.otherIncome"
                    @incomeFromOtherSource="incomeFromOtherSource"
                    >
                    </income-from-other-sources-popup>
                </template>
          </pop-up-window-lg>
          <!-- <div class="declarationContainer">

          </div> -->
        </div>
      </div> 
      <pop-up-window-lg
                v-if="taxCalculatorFlag"
                @back="goBackToDeclarationPage()"
                header="Compare Tax"
                >
      <template v-slot:content>
        <div class="view-btn-container">
          <div v-if="le_idCheck" class="view-tax-sheet-btn" @click="setDataForTaxSheet">View Tax Sheet</div>
        </div>
        <div class="income-tax-summary-box margintop-6">
        <div >
          <table>
            <thead>
              <tr class="tableheading">
                <th style="width:10rem;" >Section</th>
                <th style="text-align:right;" >Old Regime(₹)</th>
                <th style="text-align:right;padding-right:50px">New Regime(₹)</th>
              </tr>
            </thead>
            <tbody class="tableData">
               <tr v-for="taxCalculationSummary in taxCalculationCompareArray">
                <td >{{ taxCalculationSummary.name}}</td>
                <td style="text-align:right">{{  taxCalculationSummary.oldRegime.toLocaleString('en-in') }}</td>
                <td style="text-align:right;padding-right:50px">{{ taxCalculationSummary.newRegime.toLocaleString('en-in') }}</td>
               </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div  style="display: flex;gap:20px;" class="income-tax-summary-box margintop-6">
            <img
            style="cursor: pointer; margin-left: 5px; vertical-align: middle;height: 19px; width: 19px;"
            src="@/assets/info-black.svg"
            @click = "showSec10TooltipPopup = true"    
          />
          <div><span style="font-weight: 600;">{{ regimeRecommended }}</span> is recommended for you. It would save you Rs. {{ taxSavedIfNewRegime.toLocaleString('en-in') }} in  Income tax</div>
            </div>
           
             <btn-grp style="display: flex; justify-content: flex-end;">
            <btn text="Back" type="primary" @click="goBackToDeclarationPage()" />
               </btn-grp> 
        
      </template>

      </pop-up-window-lg>
      <pop-up-window-lg
                v-if="taxSheetViewFlag"
                @back="taxSheetViewFlag = !taxSheetViewFlag"
                header="Tax Sheet"
                >
      <template v-slot:content>
      <div class="income-tax-summary-box margintop-6">
        <div >
          <table>
            <thead>
              <tr class="tableheading">
                <!-- <th  style="max-width:100px;">SL NO</th> -->
                <th style="max-width:40px;" >Particulars</th>
                <th style="text-align: right; padding-right:100px;">Amount(₹)</th>
              </tr>
            </thead>
            <tbody class="tableData">
               <tr v-for="(taxSimulatorData,index) in letSheetData">
                <!-- <td>{{index+1}}</td> -->
                <td v-if="taxSimulatorData.color == 'white'" >{{ taxSimulatorData.name }}</td>
                <td v-if="taxSimulatorData.color == 'blue'" :style="{color:taxSimulatorData.color == 'white'?'black':'blue'}" v-on:click="openSection1-10">{{ taxSimulatorData.name }}</td>
                <td v-if="taxSimulatorData.color == 'blue'" >{{ }}</td>
                <td v-if="taxSimulatorData.color == 'white'" style="text-align:right;padding-right:100px;" >{{taxSimulatorData.value.toLocaleString('en-in') }}</td>
               </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
      </pop-up-window-lg>
      <!-- <div v-if="employeeRegimeType == 'New Regime'">
      <div class="twoColumnGridDashboard marginContainer">
          <div class="declarationContainer" @click="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu">
              <div class="">
                <img src="@/assets/deduction_under_80CD.svg"/>
              </div>
              <div class=""> 
                <p class="heading-text">Deduction under 80C, 80D</p>
                <span class="sub-heading-details-sm">
                  Section 80C offers tax deductions on different types of 
                  tax-saving investments, such as ULIP,PPF, premium, etc.
                </span>
                <p class="total-amount-text">Total Amount: ₹{{ chapterVIATotalAmount }}</p>
              </div>
              <div class="arrow-left-align">
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
              </div>
          </div>

        <pop-up-window-lg
              v-if="showPopupDeductionUnderCdeu"
              @back="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu"
              header="Deduction Under Chapter VI A"
              >
                <template v-slot:content>
                  <less-deduction-under-chapter-VIA-popup 
                  @back="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu"
                  :regimeType = "employeeRegimeType"
                  :ChapterVIA="data2.deductionsUnderChapterVIA"
                  @chapterVIA="chapterVIA"
                  >
                  </less-deduction-under-chapter-VIA-popup>
              </template>
        </pop-up-window-lg>

        <div class="declarationContainer" @click="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty">
              <div class="">
                <img src="@/assets/incomeLossFromHousingProperty.svg"/>
              </div>
              <div class=""> 
                <p class="heading-text">Income/Loss from Housing Property</p>
                <span class="sub-heading-details-sm">
                  A taxpayer can claim deduction under Section 24 of interest paid 
                  on home loan for each of the houses separately.
                </span>
                <p class="total-amount-text">Total Amount: ₹{{ section24TotalAmount }}</p>
              </div>
              <div class="arrow-left-align">
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
              </div>
          </div>
          <pop-up-window-lg
                v-if="showPopupIncomeLossFromHousingProperty"
                @back="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty"
                header="Section 24A"
                >
                  <template v-slot:content>
                    <income-loss-from-house-property-popup
                    @back="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty"
                          :Section24="data2.section24"
                          @incomeLossFromHousingProperty="incomeLossFromHousingProperty"
                    >
                    </income-loss-from-house-property-popup>
                </template>
          </pop-up-window-lg>

          <div class="declarationContainer" v-if="!isFirstMonth" @click="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer">
              <div class="">
                <img src="@/assets/incomeFromPreviousEmployer.svg"/>
              </div>
              <div class=""> 
                <p class="heading-text">Income from Previous Employer</p>
                <span class="sub-heading-details-sm">
                  It's not mandatory that you should report your previous
                  employer salary income and TDS amount deducted.
                </span>
                <p class="total-amount-text">Total Amount: ₹{{ previousEmployerAmount }}</p>
              </div>
              <div class="arrow-left-align">
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
              </div>
          </div>
          <pop-up-window-lg
                v-if="showPopupIncomeFromPreviousEmployer"
                @back="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer"
              
                header="Income From Previous Employer"
              
                >
                  <template v-slot:content>
                    <income-from-previous-employer 
                    @back="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer"
                    :previousEmploymentDetails="data2.previousEmploymentDetails"
                    @previousDataUpdate="previousDataUpdate"
                    >
                    </income-from-previous-employer>
                </template>
            </pop-up-window-lg>

            <div class="declarationContainer" @click="showPopupOtherIncome = !showPopupOtherIncome">
              <div class="">
                <img src="@/assets/other_income.svg"/>
              </div>
              <div class=""> 
                <p class="heading-text">Other Income</p>
                <span class="sub-heading-details-sm">
                  Other income is income that does not come from a company's
                  main business, such as interest.
                </span>
                <p class="total-amount-text">Total Amount: ₹{{ otherIncomeAmount }}</p>
              </div>
              <div class="arrow-left-align">
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
              </div>
          </div>
          <pop-up-window-lg
                v-if="showPopupOtherIncome"
                @back="showPopupOtherIncome = !showPopupOtherIncome"
                header="Other Income"
                >
                  <template v-slot:content>
                    <income-from-other-sources-popup
                    @back="showPopupOtherIncome = !showPopupOtherIncome"
                    :IncomeOtherSource="data2.otherIncome"
                    @incomeFromOtherSource="incomeFromOtherSource"
                    >
                    </income-from-other-sources-popup>
                </template>
          </pop-up-window-lg>
            
          <div class="declarationContainer">

          </div> -->
        <!-- </div>
      </div>  --> 

      <bottom-action-container>
        <p class="submitNote">Please click on the Submit button to submit the declaration for payroll.</p>
        <template slot="end">
          <btn-grp>
            <btn text="Back" type="secondary" @click="goBackToPayslip" />
            <btn text="Submit" type="primary" v-if="itEnableValue" @click="saveEssIT('submit')"/>   
          </btn-grp>
        </template>
      </bottom-action-container>
      <pop-up-message
        v-if="showSuccessMsg"
        :message="popUpMessage"
        btnText="OK"
        @back="goBack"
      ></pop-up-message>
    </div>
   </div>
</template>
<script>
import moment from 'moment';
import { mapGetters, mapActions, mapState } from "vuex";
import hraExemptionPopup from "./itDeclarationDashboardPopup/hraExemptionPopup.vue";
//import DeductionUnderCdeu from "../payroll/incometax/deductionsUnderCdeu.vue";
import lessDeductionUnderChapterVIAPopup from "./itDeclarationDashboardPopup/lessDeductionUnderChapterVIAPopup.vue";
//import DeductionUnderSectionSixteen from "../payroll/incometax/deductionUnderSectionSixteen.vue";
import ExemptionUnderSectionSeventeen from "../payroll/incometax/exemptionUnderSectionSeventeen.vue";
import IncomeFromPreviousEmployer from "./itDeclarationDashboardPopup/incomeFromPreviousEmployerPopUp.vue";
import OtherIncome from "../payroll/incometax/otherIncome.vue";
//import IncomeLossFromHousingProperty from "../payroll/incometax/incomeLossFromHousingProperty.vue";
import incomeLossFromHousePropertyPopup from "./itDeclarationDashboardPopup/incomeFromHousePropertyPopUp.vue";
import incomeFromOtherSourcesPopup from "./itDeclarationDashboardPopup/incomeFromOtherSourcesPopup.vue";
import sectionTenExemption from "./itDeclarationDashboardPopup/section10OtherExemption.vue"


export default {
  components: {
    hraExemptionPopup,
    //DeductionUnderCdeu,
    //DeductionUnderSectionSixteen,
    lessDeductionUnderChapterVIAPopup,
    ExemptionUnderSectionSeventeen,
    incomeLossFromHousePropertyPopup,
    IncomeFromPreviousEmployer,
    incomeFromOtherSourcesPopup,
    sectionTenExemption
    // IncomeLossFromHousingProperty
  },
  data() {
    return {
      retryCount:0,
      loadingMessage:'Processing...!!',
      regimeChangeCompare:'',
      taxCalculatorFlag:false,
      taxSheetViewFlag:false,
      le_id_list :['a5d421ae-b986-4ec0-ad64-f6eed8d5b3cb','5d5eadf5-3ec0-4ca1-9c9e-507be4e948f5','e5a3995e-52b9-409d-b56e-6d5851faaa78','dfba4011-0c5e-46cc-b4f4-99f5962f9ebe'],
      le_idCheck : false,
      errmsg: 'please Select the Regime and save to continue',
      popUpMessageREgime:"saved successfully",
      showRegimeSuccessMsg:false,
      toast:false,
      removeRegimeChange:false,
      financial_year_month:'',
      legalEntityName:'',
      employee_Code:"",
      regimeRecommended:"",
      taxSavedIfNewRegime:0,
      popUpMessage: '',
      saveAsDraft:true,
      itEnableValue: false,
      startDate: "",
      endDate: "",
      loading: true,
      emp_regime_type: "newregime",
      date_of_joining: null,
      isFirstMonth: false,
      employeeObj: null,
      PlanName:null,
      showPopupSalaryPerks: false,
      showPopupTdsBreakupOldRegimePopup: false,
      showPopupItDeclarationStatmentOldRegimePopup: false,
      showPopupTdsBreakupNewRegimePopup: false,
      showPopupItDeclarationStatmentNewRegimePopup: false,
      showPopupExemptionUnderSectionDeduction: false,
      showPopupExemptionUnderSection10Deduction: false,
      showPopupDeductionUnderCdeu: false,
      showPopupDeductionUnderSectionSixteen: false,
      showPopupExemptionUnderSectionSeventeen: false,
      showPopupIncomeFromPreviousEmployer: false,
      showPopupOtherIncome: false,
      showPopupIncomeLossFromHousingProperty: false,
      showConfirmationMsg: false,
      exemptionSection: "Exemption Under Section 10",
      personal: {
        first_name: null,
        last_name: null,
        code: null,
      },
      salary: {
        ctc: null,
        salary_structure_id: null,
        exempt_for_it_deduction_first_month: false,
        master_salary_structure: []
      },
      it_plan_id:"",
      employeeId:"",
      instance:{
        le_id:"",
        employee_id:"",
        financial_year:"",
        it_plan_id:"",
      },
      hraData:{
        exemption10:{
          HRA: {},
        others: []
        }
      },
      data2:{
      exemption10:{
        
      },
      exemption17:[],
      deductionsUnderSection16:[],
      deductionsUnderChapterVIA:[],
      section24:[],
      previousEmploymentDetails:{},
      otherIncome:{},
      le_id:"",
      employee_id:"",
      financial_year:"",
      plan_id:"",
      regime_type:"",
      },
      employeeRegimeType: "New Regime",
      enableSection10ForNewRegime: true,
      hraExemptionAmount: 0,
      section10ExemptionAmount: 0,
      chapterVIATotalAmount: 0,
      section24TotalAmount: 0,
      previousEmployerAmount: 0,
      otherIncomeAmount: 0,
      salaryPerk:[],
      tds_breakup_and_taxable_income:[],
      itSheet:[],
      first_name:"",
      last_name: "",
      ctc:"",
      code:"",
      totalIncomeTax:"",
      annualTax:"",
      showSuccessMsg: false,
      totalAmount_otherIncome:"",
      totalAmount_previousEmpDetails: "",
      netTaxableIncome: 0,
      totalTax: 0,
      taxToPaid: 0,
      itSheetData:[],
      headingData :[],
      taxCalculationCompareArray:[],
      newArrayDataForSimulater:[],
      section10DataTaxSheet:[],
      finalArraysection10DataTaxSheet:[],
      section24DataTaxSheet:[],
      finalArraysection24DataTaxSheet:[],
      sectionOtherIncomeTaxSheet:[],
      finalArraysectionOtherIncomeTaxSheet:[],
      sectionChapter6A:[],
      finalArraysectionChapter6A:[],
      sectionsDataTaxSheet:[],
      letSheetData:[]
    };
   
  },
  computed: {

    le_id(){
      return localStorage.getItem("le_id")
    },

    empId(){
      return localStorage.getItem("empId")
    },

     ...mapState({
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getleData: "onboard/legal_entities/record",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData"
    }),
    ...mapState({
      globalData: state => state.globalapi.globalData.data,
         }),
    ifHr() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifEmployee() {
      return localStorage.getItem("userRole") == "EMPLOYEE" || 'CLIENTADMIN' ? true : false;
    },
    
  },

    mounted() {
    this.salaryTableData = [];
    this.getItPlan();
    this.itStatusEnable();
    if(this.le_id_list.includes(this.le_id)){
      this.le_idCheck = true
    }
  },
  activated() {
    this.getItPlan()
    this.itStatusEnable();
    this.salaryTableData = [];
  },
  methods: {
    ...mapActions({
      act_fetchEmpById: "onboard/employees/fetchEmpDataById",
      fetchEmployeeCode: "onboard/employees/fetchEmployeeCode",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_fetchsalarycomponents:"onboard/settings/salary_component/fetchAllsalaryComponentsData",
      act_set_it_data:"dashboard/payroll/incometax/setItData",  
      act_get_plan:"dashboard/payroll/incometax/getPlan",
      act_save_it_plan:"dashboard/payroll/incometax/createItData",
      act_fetch_plan_name:"dashboard/payroll/incometax/getPlanName",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll', 
      act_get_it_enable:"dashboard/payroll/incometax/getItEnable",
      act_get_it_sheet_data:"dashboard/payroll/incometax/fetchItDeclarationTimeSheet",
      act_get_it_data_compare:"dashboard/payroll/incometax/fetchTaxCompareData",
      act_create: "payroll/runpayroll/create",
      act_getCount_details: "payroll/paygroups/fetchCountdetails",
    }),
    setRegimeFromRadio(val){
       if(val == 'New Regime'){
        this.employeeRegimeType = 'New Regime'
       }else if(val == 'Old Regime'){
        this.employeeRegimeType = 'Old Regime'
       }
       this.calculateTotalAmount()
    }, 
    async goBackToDeclarationPage(){
        this.taxCalculatorFlag = !this.taxCalculatorFlag
        this.getItPlan()
    },
    async compareTaxFunction(){
     try{
      let payload = {
          employee_id: this.empId,
          month: this.financial_year_month,
          financial_year: this.financial_year,
          legal_entity_id: this.le_id
        }
      let res = await this.act_get_it_data_compare(payload)
              if (res && Object.keys(res).length > 0 && res && Object.keys(res.oldRegime).grossSalary != 0) {
                this.loading = false
                this.taxCalculatorFlag = true
                let compareData = res
                this.taxCalculationCompareArray = Object.keys(compareData.oldRegime).map((key) => {
                  return {
                    name: this.functionToChangeNameBasedOnCode(key),
                    oldRegime: compareData.oldRegime[key] !== null ? compareData.oldRegime[key] : 0 ,
                    newRegime: compareData.newRegime && compareData.newRegime[key] !== null ? compareData.newRegime[key] : 0
                  };
                });
                this.taxCalculationCompareArray.map(data => {
                  if (data.name == "Final Tax") {
                    this.taxSavedIfNewRegime = Math.abs(data.newRegime - data.oldRegime)
                    if (data.newRegime > data.oldRegime) {
                      this.regimeRecommended = 'Old Tax Regime'
                    } else if (data.oldRegime >= data.newRegime) {
                      this.regimeRecommended = 'New Tax Regime'
                    }
                  }
                })
              }
              else if (!res || Object.keys(res).length === 0) {
                if (this.retryCount < 3) {
                  this.retryCount++;
                  setTimeout(() => { this.compareTaxFunction(); }, 10000);
                  this.loading = true;
                  this.taxCalculatorFlag = true;
                  this.loadingMessage = 'Data is processing. Please wait...!';
                } else {
                  this.loading = false;
                  this.taxCalculatorFlag = false;
                  this.toast = true;
                  this.errmsg = 'Data is processing. Please try again.';
                }
              }
              else if (res || Object.keys(res).length !== 0 && Object.keys(res.oldRegime).grossSalary == 0) {
                  this.loading = false;
                  this.taxCalculatorFlag = false;
                  this.toast = true
                  this.errmsg = "Problem while fetching data. Please try again later"
                }
              
     }catch(err){
      this.loading = false
      this.toast = true
      this.errmsg = "Problem while fetching data. Please try again later"
     }
    },
    async taxCompareFunction() {
      try {
       let data = await this.triggerRunPayroll()
        if(data){
        if (false) {
          this.toast = true
          this.errmsg = "Please Submit the tax declaration before you compare the tax details"
        } else {
          this.loading = true
          setTimeout(()=>{this.compareTaxFunction()},10000)
        }}
      } catch (err) {
        this.loading = false
        this.toast = true
        this.errmsg = 'Error while fetching Data'
      }
    },
    functionToChangeNameBasedOnCode(key){
      return key
             .replace(/([a-z])([A-Z])/g, '$1 $2') 
             .replace(/^./, (match) => match.toUpperCase());
            
    },
    async setDataForTaxSheet(){
     try{
      this.loading = true
      setTimeout(()=>{
        this.taxSheetViewFlag = true
        this.loading = false
      },4000)
      
      let regime = (this.employeeRegimeType == 'New Regime' ? 'newregime': this.employeeRegimeType == 'Old Regime' ? 'oldregime':'newregime')
      let payload={
        employee_id:this.empId,
        month: this.financial_year_month,
        financial_year: this.financial_year,
        legal_entity_id:this.le_id,
        regime_type:regime
      }
      let res = await this.act_get_it_sheet_data(payload)
      this.itSheetData = res[0].itSheetData
       this.letSheetData = this.itSheetData.sort((a, b) => a.order - b.order);
       this.letSheetData.map((data, index) => {
         if (typeof (data.value) !== Number) {
           if (data.code == 'sec10_exempt') {
             const res = data.value.map(key => ({
               color: "white",
               ...key
             }))
             console.log(res)
             res.map((data, indexData) => {
               this.letSheetData.splice(index + 1 + indexData, 0, data)
             })
           } else if (data.code == "deductions_sec16") {
             const res = data.value.map(key => ({
               color: "white",
               ...key
             }))
             res.map((data, indexData) => {
               this.letSheetData.splice(index + 1 + indexData, 0, data)
             })
           }
           else if (data.code == "ded_chapter_via") {
             const res = data.value.map(key => ({
               color: "white",
               ...key
             }))
             res.map((data, indexData) => {
               this.letSheetData.splice(index + 1 + indexData, 0, data)
             })
           }
           else if (data.code == "inc_from_other") {
             const res = data.value.map(key => ({
               color: "white",
               ...key
             }))
             res.map((data, indexData) => {
               this.letSheetData.splice(index + 1 + indexData, 0, data)
             })
           }
         }

})
     }catch(err){
      this.loading = false
      this.toast = true
      this.errmsg = err
     }
    },
    async regimeChange(val){
        this.removeRegimeChange = true
    },
    async triggerRunPayroll(){
      try{
        // check the declaration based on that enable regime change option
        let declared = sessionStorage.getItem('isDeclared');
      if(declared == "true" || declared == true){
        this.removeRegimeChange = true
        this.saveAsDraft = false
        this.toast = false
      }else{
        this.removeRegimeChange = false
        this.toast = false
      }
        // run the payroll to get comparistion data
       let resDataPayload={
         le_id: this.le_id, payroll_month: this.financial_year_month, financial_year: this.financial_year
        }
        const resData = await this.act_getCount_details(resDataPayload)
        let paygroups = resData.data.payload.data.map(item => ({
          id: item.id
        }));
        let obj = {
          paygroups: paygroups,
          legal_entity_id: this.le_id,
          legal_entity_name: this.legalEntityName,
          month: this.financial_year_month,
          financial_year: this.financial_year,
          employeeIds: [this.employee_Code] || [],
          total_employees: 1,
          compare_tax:true,
          regime_type:"oldregime"
        };
        let res = await this.act_create(obj);

        if(res){
          let obj = {
          paygroups: paygroups,
          legal_entity_id: this.le_id,
          legal_entity_name: this.legalEntityName,
          month: this.financial_year_month,
          financial_year: this.financial_year,
          employeeIds: [this.employee_Code] || [],
          total_employees: 1,
          compare_tax:true,
          regime_type:"newregime"
        };
        let res = await this.act_create(obj);
        if(res){
          return  "Api Called"
        }
        }
      }catch(err){
       this.toast = true
       this.errmsg = err
      }
    },
    getFinancialYear(date = new Date()) {
      const year = date.getFullYear();
      const month = date.getMonth(); // January is 0, April is 3

      // If the month is Jan (0), Feb (1), or March (2), it belongs to the previous FY
      if (month < 3) {
        return `${year-1}`;
      } else if(month >=3) {
        return `${year}`;
      }
    },
    async getItPlan() {
      try {
        this.loading = true;
        let res = await this.act_get_plan(this.empId)
        this.planList = res.data.payload.filter( ele => ele.is_plan_active == true);
        this.it_plan_id = this.planList[0].id;
        let obj = {
          'employee_id': this.empId
        };
        let response = await this.act_getProfileData(obj);
        this.financial_year = response.data.payload[0].payrollDetails.year;
        this.financial_year_month = response.data.payload[0].payrollDetails.month;
        this.employee_Code= response.data.payload[0].code
        this.legalEntityName = response.data.payload[0].legalEntityDetails.legalName;
        this.date_of_joining = response.data.payload[0].date_of_joining;
        // let joiningMonth = this.date_of_joining.split("-")[1];
        // if(joiningMonth == "04"){
        //   this.isFirstMonth = true;
        // }
        let dateOfJoingYear = this.date_of_joining.split("-")[0]
        let joiningMonth = this.date_of_joining.split("-")[1];
        let dateOfJoin = this.date_of_joining.split("T")[0].split("-")[2]
        let currentFinancialyear = this.getFinancialYear(new Date())
        this.isFirstMonth = Number(joiningMonth) == 4 && (dateOfJoin && Number(dateOfJoin) > 1) && (dateOfJoingYear == currentFinancialyear) ? true : Number(joiningMonth) > 4 && (dateOfJoingYear == currentFinancialyear)? true : false;
        // this.triggerRunPayroll()
        if(this.it_plan_id){
          await this.fetchRecord();
        }
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } catch (error) {
        console.log(error)
        // this.toast = true;
        // this.errmsg = error.message;
        setTimeout(() => {
          this.loading = false;
        }, 400);
      } 
    },
    
   async fetchRecord() {
      this.instance.employee_id = this.empId;
      this.instance.financial_year = this.financial_year;
      this.instance.it_plan_id = this.it_plan_id;
      this.instance.le_id = this.le_id;
      let res = await this.act_set_it_data(this.instance)
      if (res.status) {
        this.hraData.exemption10.others = res.data.payload.Exemption10 && res.data.payload.Exemption10.others
        this.data2.exemption10 = res.data.payload.Exemption10.HRA && res.data.payload.Exemption10.HRA.length == 0 ? this.hraData.exemption10 : res.data.payload.Exemption10;
        this.data2.exemption17 = res.data.payload.Exemption17;
        this.data2.deductionsUnderSection16 = res.data.payload.deductionsUnderSection16;
        this.data2.deductionsUnderChapterVIA = res.data.payload.deductionsUnderChapterVIA;
        this.data2.itDeclarationStatus = res.data.payload.itDeclarationStatus;
        this.regimeChangeCompare = res.data.payload.regime_type
        if(res.data.payload.itDeclarationStatus == "true" || res.data.payload.itDeclarationStatus == true){
        sessionStorage.setItem("isDeclared",true)
        }
        let declared = sessionStorage.getItem('isDeclared');
      if(declared == "true" || declared == true){
        this.removeRegimeChange = true
        this.saveAsDraft = false
        this.toast = false
      }else{
        this.removeRegimeChange = false
      }
        this.data2.itDeclarationSaveAsDraft = res.data.payload.itDeclarationSaveAsDraft
        this.data2.deductionsUnderChapterVIA.map(element => {
          if(!element.hasOwnProperty("planned")){
            element.planned = 0;
          }
        })
        this.data2.section24 = res.data.payload.section24;
        this.data2.previousEmploymentDetails = res.data.payload.previousEmploymentDetails;
        // this.totalAmount_previousEmpDetails = this.data2.previousEmploymentDetails.nps.amount +
        //   this.data2.previousEmploymentDetails.pf.amount +
        //   this.data2.previousEmploymentDetails.pt.amount +
        //   this.data2.previousEmploymentDetails.salary_income.amount +
        //   this.data2.previousEmploymentDetails.tds.amount +
        //   this.data2.previousEmploymentDetails.vpf.amount;
        this.data2.otherIncome = res.data.payload.otherIncome;
        this.totalAmount_otherIncome = this.data2.otherIncome && this.data2.otherIncome.reduce((total, i) => {
          total = total + i.planned;
          return total;
        }, 0)
        this.salaryPerk = res.data.payload && res.data.payload.Salary;
        this.tds_breakup_and_taxable_income = res.data.payload.tds_breakup_and_taxable_income && res.data.payload.tds_breakup_and_taxable_income;
        this.itSheet = res.data.payload.itSheet && res.data.payload.itSheet;
        let itSheetLength = this.itSheet.length;     
        this.netTaxableIncome = this.itSheet[0] ? this.itSheet[0].taxableIncome : 0;
        this.totalTax = this.itSheet[0] ? this.itSheet[0].totalTax : 0;
        this.taxToPaid = this.itSheet[0] ? this.itSheet[0].tds : 0;
        this.emp_regime_type = res.data.payload.regime_type;
        this.enableSection10ForNewRegime = res.data.payload.enableSection10ForNewRegime;
        if(res.data.payload.regime_type == "newregime"){
          this.employeeRegimeType = "New Regime"
        }else if(res.data.payload.regime_type == "oldregime"){
          this.employeeRegimeType = "Old Regime"
        }
        this.calculateTotalAmount();
        //console.log("TDS data show", this.tds_breakup_and_taxable_income);
        //console.log("IT sheet data ",this.itSheet);
      }
    },

    backpreviouspage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
        query: { id: this.employeeId }
      });
    },

    calculateTotalAmount(){
      this.hraExemptionAmount = 0,
      this.chapterVIATotalAmount = 0,
      this.section24TotalAmount = 0,
      this.previousEmployerAmount = 0,
      this.otherIncomeAmount = 0,
      this.section10ExemptionAmount = 0
      this.data2.exemption10.HRA && this.data2.exemption10.HRA.planned && this.data2.exemption10.HRA.planned.details && this.data2.exemption10.HRA.planned.details.map(element => {
        this.hraExemptionAmount += Number(element.value);
      });
      this.data2.exemption10.others && this.data2.exemption10.others.map(element => {
        if (!element.hasOwnProperty("planned")) {
          element.planned = 0;
        }

        if (element.is_fbp_component) {
          if (element.planned !== 0) {
            this.section10ExemptionAmount += Number(element.planned);
          }
          else if (element.planned == 0) {
            this.section10ExemptionAmount += Number(element.exemption_value);
          }
        } else {
          if (element.planned !== 0) {
            this.section10ExemptionAmount += Number(element.planned);
          }
          else if (element.planned == 0) {
            this.section10ExemptionAmount += 0
          }
        }
      })
      let preEmployerData = this.data2.previousEmploymentDetails && Object.values(this.data2.previousEmploymentDetails);
      preEmployerData && preEmployerData.map(element => {
        this.previousEmployerAmount += element.planned;
      });
      this.data2.deductionsUnderChapterVIA && this.data2.deductionsUnderChapterVIA.map(element => {
        if(this.employeeRegimeType == "New Regime"){
          // if(element.InvestmentComponentType.name == "NPS Employer Contribution" ||  element.InvestmentComponentType.name == "NPS Employer Contribution - Previous Employer")
          if(element.InvestmentComponentType.name == "NPS Employer Contribution" ){
            this.chapterVIATotalAmount += element.planned;
            this.chapterVIATotalAmount += element.exemption_value
          }
        }else{
          this.chapterVIATotalAmount += element.planned;
          this.chapterVIATotalAmount += element.exemption_value
        }
        
      })
      this.data2.otherIncome && this.data2.otherIncome.map(element => {
        this.otherIncomeAmount += element.planned;
      })
      let result = 0;
      this.data2.section24.let_out_property && this.data2.section24.let_out_property.map(el => {
            result += el.total_planned
          });
          if(this.employeeRegimeType == "New Regime"){
           this.section24TotalAmount = (result < -200000) ? -200000 : result;
           this.section24TotalAmount = this.section24TotalAmount ? this.section24TotalAmount : 0;
          }else{
      this.section24TotalAmount = (this.data2.section24.self_occupied && this.data2.section24.self_occupied.total_planned + result < -200000) ? -200000 : this.data2.section24.self_occupied && this.data2.section24.self_occupied.total_planned + result;
      this.section24TotalAmount = this.section24TotalAmount ? this.section24TotalAmount : 0;
          }
    },

    formattedDateData(){
      this.data2.exemption10.HRA.planned.details = this.data2.exemption10 && this.data2.exemption10.HRA.planned.details.map(item => ({
        ...item,
        from: moment(item.from).format('YYYY-MM-DD'),
        to: moment(item.to).format('YYYY-MM-DD')
      }));
    },

    hraExemptionFun(Exemption10) {
      this.hraExemptionAmount = 0;
      this.showPopupExemptionUnderSectionDeduction = false;
      this.data2.exemption10 = Exemption10;
      this.data2.exemption10.HRA.planned.details.map(element => {
        this.hraExemptionAmount += Number(element.value);
      })
      this.formattedDateData();
      this.saveEssIT('draft');
    },

    section10ExemptionFun(Exemption10Others){
      this.section10ExemptionAmount = 0;
      this.showPopupExemptionUnderSection10Deduction = false;
      this.data2.exemption10 = Exemption10Others;
      this.data2.exemption10.others.map(element => {
        if (element.is_fbp_component) {
          if (element.planned !== 0) {
            this.section10ExemptionAmount += Number(element.planned);
          }
          else if (element.planned == 0) {
            this.section10ExemptionAmount += Number(element.exemption_value);
          }
        } else {
          if (element.planned !== 0) {
            this.section10ExemptionAmount += Number(element.planned);
          }
          else if (element.planned == 0) {
            this.section10ExemptionAmount += 0;
          }
        }

      })
      this.saveEssIT('draft');
    },

    section17update(Exemption17) {
      this.showPopupExemptionUnderSectionSeventeen = false;
      this.data2.exemption17 = Exemption17;
    },
    
    previousDataUpdate(previousEmpData) {
      this.previousEmployerAmount = 0;
      this.showPopupIncomeFromPreviousEmployer = false;
      this.data2.previousEmploymentDetails = previousEmpData;
      let preEmployerData = Object.values(this.data2.previousEmploymentDetails);
      preEmployerData.map(element => {
        this.previousEmployerAmount += element.planned;
      })
      this.saveEssIT('draft');
    },

    chapterVIA(chapterData){
      this.chapterVIATotalAmount = 0;
      this.showPopupDeductionUnderCdeu=false;
      this.data2.deductionsUnderChapterVIA=chapterData;
      this.data2.deductionsUnderChapterVIA.map(element => {
        this.chapterVIATotalAmount += element.planned;
      })
      this.saveEssIT('draft');
    },

    incomeFromOtherSource(otherIncomeList){
      this.otherIncomeAmount = 0;
      this.showPopupOtherIncome=false;
      this.data2.otherIncome=otherIncomeList;
      this.data2.otherIncome.map(element => {
        this.otherIncomeAmount += Number(element.planned);
      })
      this.saveEssIT('draft');
    },

    incomeLossFromHousingProperty(Section24Update){
      this.showPopupIncomeLossFromHousingProperty=false;
      this.data2.section24=Section24Update;
      this.data2.section24.self_occupied.total_planned = this.data2.section24.self_occupied.total_planned ? this.data2.section24.self_occupied.total_planned*(-1) : 0;
      // let result = 0;
      //     this.data2.section24.let_out_property.map(el => {
      //       result += el.total_planned
      //     });
      // this.totalExemptionPlanned = (-this.data2.section24.self_occupied.total_planned + result < -200000) ? -200000 : -this.section24.self_occupied.total_planned + result;
      // this.totalExemption = this.Section24.let_out_property[0].total_actual + this.section24.self_occupied.total_actual;
      this.section24TotalAmount = Math.abs(this.data2.section24.grandTotal);
      this.saveEssIT('draft');
    },

    saveplan() {
      this.showConfirmationMsg = true;
    },

  async saveTaxRegime() {
    try {      
      this.data2.plan_id=this.instance.it_plan_id;
      this.data2.employee_id= this.empId
      this.data2.financial_year=this.instance.financial_year;
      this.data2.le_id= this.le_id;
      this.showConfirmationMsg = false;
      let res = await this.act_save_it_plan(this.data2);
      if(res.status){
        this.showConfirmationMsg = false;
      }else{
        //console.log("make mistake try again...........");
      }
    } catch (error) {
      
    }
      
      
    },

    /* function to hide the confimation pop-up */
    cancelEvent() {
      this.showConfirmationMsg = false;
    },

    //cancel() {
      //this.$router.push({
        //path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax`
      //});
      // this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/updateFixedNonCtcComponents`
      // });
    //},

    goItSimulator(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/mysalary/itDeclarationDashboard`,
      });
    },

    popupMessage() {
      this.exemptionSection =  "Add House on Rent";
      //location.reload();
    },

    changeHeaderTitle() {
      this.exemptionSection = "Exemption Under Section 10";
      this.showPopupExemptionUnderSectionDeduction = false;
    },

    goBack() {
      this.showSuccessMsg = false;
      this.fetchRecord();
    },
    goBackRegime(){
      this.showRegimeSuccessMsg =  false
    },
    goBackToPayslip(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/overview/feed`,
      });
    },

    async itStatusEnable() {
      let res = await this.act_get_it_enable({le_id:this.le_id});
      let time = new Date();
      let day = time.getDate();
      // console.log("Time", day);
      
      this.itEnableValue = res.data.payload.data.ITDeclarationSetting.ITEnable;

      
      this.startDate = res.data.payload.data.ITDeclarationSetting.startDate;
      this.endDate = res.data.payload.data.ITDeclarationSetting.endDate;
      // day <= this.endDate ? this.itEnableValue = true : this.itEnableValue = false;
      // day >= this.startDate && day <= this.endDate ? this.itEnableValue = true : this.itEnableValue = false;
    //  console.log("IT Enable", this.itEnableValue, this.startDate <= day <= this.endDate);
    },

    updateSelfOccupiedPlanned() {
      if (this.data2.section24 && this.data2.section24.self_occupied && this.data2.section24.self_occupied.total_planned !== undefined) {
        this.data2.section24.self_occupied.total_planned = this.data2.section24.self_occupied.total_planned > 0
          ? -this.data2.section24.self_occupied.total_planned
          : this.data2.section24.self_occupied.total_planned;
      }
    },

    async saveEssIT(data) {
      try {
        let regime = (this.employeeRegimeType == 'New Regime' ? 'newregime': this.employeeRegimeType == 'Old Regime' ? 'oldregime':'newregime')
        this.data2.plan_id = this.instance.it_plan_id;
        this.data2.employee_id = this.empId;
        this.data2.financial_year=this.financial_year;
        this.data2.le_id = this.le_id;
        //this.instance.financial_year = this.financial_year;
        this.data2.regime_type = regime;
        if(this.regimeChangeCompare !== regime){
           this.data2.regime_changed = true
        }
        else{
          this.data2.regime_changed = false
        }
        if(data == 'draft'){
          this.data2.itDeclarationSaveAsDraft = true
        }else if(data !== 'draft'){
          this.data2.itDeclarationStatus = true;
        }
      
        this.data2.isEmployee= "true"
        await this.updateSelfOccupiedPlanned();
        // this.data2.section24.self_occupied.total_planned = this.data2.section24.self_occupied.total_planned > 0 ? -this.data2.section24.self_occupied.total_planned : this.data2.section24.self_occupied.total_planned;

          this.loading = true
          let res = await this.act_save_it_plan(this.data2);
          if (res.status) {
            this.loading =  false
          this.showSuccessMsg = true;
          // this.triggerRunPayroll()
          if(data == 'draft'){
            this.popUpMessage = 'Saved as draft'
          }else{
            this.regimeChange()
            this.popUpMessage = 'Save Successfully'
          }
        } else {
          //console.log("make mistake try again...........");
        }
       
      } catch (error) {
        this.loading =  false
        this.toast = true;
        this.errmsg = error.message;
      }
      
    },
  
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";
.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}

.declarationContainer{
  width: 100%;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  border-radius: 8px;
  border: solid 1px #F0F0F0;
  background-color: #ebebeb;
  cursor: pointer;
}

.marginContainer{
  margin-top: 25px;
}

.headingContainer{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
}

.headingLeftContainer{
  width: 100%;
  display: flex;
  gap: 15px;
}

.headingRightContainer{
  // width: 30%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap:5px
}

.mask {
  width: 258.5px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
}
.center{
  margin: 500px ;
}
.resize{
  margin-left: 100px;
}
.bold-text{
    width: 345px;
  height: 24px;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  margin-top: 40px;
}
.add-new{
    width: 68px;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}
.click-on-Add-New-t {
  width: 403px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  // margin-left: -30px;
  margin-top: 10px;
}
.oval {
  // background-color: #ffa000;
  width: 75px;
  height: 75px;
  border-radius: 50px;
}

.add-btn-small {
  margin-top: 30px;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;
  &:nth-child(n) {
    margin-right: 20px;
  }
  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }
  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }
  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}
.noData span {
  font-size: 18px;
  color: #858585;
}
.lineheight{
  height: 1px;
}

.img-user {
    margin-right: 10px;
    position: absolute;
}

.month {
    position: relative;
    margin-left: 40%;
}

.employee-fullname {
  text-transform: capitalize;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.employee-code {
  font-size: 12px;
  font-weight: normal;
  color: #979797;
}

.salary-perks {
  margin-top: 30px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.salary-ctc {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.close-card {
    position: absolute;
    cursor: pointer;
    color: #5d409f;
    right: 10px;
    top: 4px;
}

.document-new-block {
  margin-left: auto;
  margin-right: auto;
  margin-top: 18%;
  width: 400px;
  text-align: center;
}

.add-new-icon-document {
  display: inline-flex;
  cursor: pointer;
  margin-top: 15px;
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

#example {
  margin-top: 20px;
}

#example .col-4 {
  border: 1px solid #c9c9c9;
}

#example .col-4:not(:last-child) {
  border-right-width: 0;
}

#example .row:not(:last-child) .col-4 {
  border-bottom-width: 0;
}

#example .col-5 {
  border: 1px solid #c9c9c9;
}

#example .col-5:not(:last-child) {
  border-left-width: 0;
  border-right-width: 0;
}

// #example .row:not(:last-child) .col-5 {
//   border-bottom-width: 0;
// }

.first {
    height: 210px;
    padding: 32px;
    border-radius: 10px 0px 0px 10px;
    border: solid 1px #dddddd;
}    

.middle {
    max-width:37%;
    height: 210px;
    padding: 32px;
    // border-radius: 10px 0px 0px 10px;
    // border: solid 1px #dddddd;
}

.last {
    max-width: 37%;
    flex: 0 0 37%;
    height: 210px;
    padding: 32px;
    border-radius: 0px 10px 10px 0px;
    border: solid 1px #dddddd;
}

.view-salary-breakup {
  margin: 22px 0px 0px 0px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #34c0be;
  cursor: pointer;
}

.view-btn-container{
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

.view-tax-sheet-btn {
  border: #34C0BD solid 1px;
  background: #34C0BD;
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  width: max-content;
  // min-height: 30px;
  text-align: center;
  padding: 10px;
  margin-top: -15px;
  cursor: pointer;
}

.regime-title {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.badget-custom {
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color:#ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

.icon-i {
  // margin: 0px 12px;
  transform: translate(0px, 7px);
}

.total-taxable-income {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.taxable-amount {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
  // margin-right: 20px;
  text-align: right;
}

.custom-width-block-19 {
  width: 14%;
}

.custom-width-block-13 {
  width: 13%;
}
.icon-move-right {
  float: right;
  margin-right: 7px;
}

.custom-col {
  margin-right: 0px;
}

.deduction-title {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.line {
  width: 1px;
  display: inline-block;
  height: 19px;
  margin: 0px 13px 0px 10px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.block-deductions {
  width: 404px;
  // height: 145px;
  padding: 24px 16px 24px 16px;
  border-radius: 8px;
  border: solid 1px #efefef;
  background-color: #ffffff;
  cursor: pointer;
}

.block-deductions-title {
  margin-bottom: 8px;
}

.block-deductions-sub-title {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.deduction-img {
  text-align: right;
  transform: translate(0px, 0px);
}

.amount-deduction {
  text-align: right;
  display: block;
}

.progress-bar-blue {
  margin-top: 10px;
  width: 340px;
  border-radius: 10px;
  height: 10px;
  background-color: #dadada;
}

.progress-target {
  background-color:#34c0be;
  border-radius: 10px;
  height: 10px;
  width: 94px;
}

.progress-target-full {
  background-color:#34c0be;
  border-radius: 10px;
  height: 10px;
  width: 340px;
}



  .modal {
    display: block;
    position: fixed;
    z-index: 6;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    // background-color: rgba(0, 0, 0, 0.3);
    background: rgba(0, 0, 0, 0.60);
    -webkit-backdrop-filter: blur(14px);
    backdrop-filter: blur(10px);
  }

  /* Modal Content */

  .modal-content {
    background-color: white;
    margin: 150px auto 0px auto;
    z-index: 20;
    width: 30%;
    // height: 191px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 12px;
    opacity: 0;
    padding: 30px 30px 30px 30px;
    -webkit-animation-name: showPopup;
    -webkit-animation-duration: 0.3s;
    -webkit-animation-delay: 0s;
    -webkit-animation-iteration-count: 1;
    // -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-fill-mode: forwards;

    .success-icon {
      // margin-bottom: 40px;
    }

    .success-text {
      font-size: $font-size-l1;
      font-weight: 600;
      // margin-bottom: auto;
      margin-left: 12px;
      color: #6e6e6e;
    }

    .message-text {
      font-size: $font-size-l1;
      margin-bottom: 20px;
      line-height: 25px;
      animation-delay: 0.7s;
      animation-name: fadeInRight;
      -webkit-animation-name: fadeInRight;
    }
    .btn-confirm-delete{
      display: flex;
      align-items: center;
      *:nth-child(n){
        margin-right: 20px;
      }
    }
    .warning {
      margin-bottom: 16px;
      text-align: center;
      height: 24px;
      width: 24px;
    }
    .btn-popup {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: $color-primary;
      color: $color-white;
    }
    .btn-popup-secondary {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: #ffffff;
      border: #34c0be solid 2px;
      color: #34c0be;
    }

    .close-btn {
      position: relative;
      transform: scale(2);
      left: 230px;
      bottom: 20px;
      cursor: pointer;
    }
  }
  .success-img {
    position: relative;
    height: 24px;
    width: 24px;
    &.animated {
      animation-name: pulse;
      animation-iteration-count: infinite;
      animation-duration: 3s;
      -webkit-animation-name: pulse;
      -webkit-animation-iteration-count: infinite;
      -webkit-animation-duration: 3s;
    }
}
.warn-img {
  position: relative;
  height: 24px;
  width: 24px;
}
.warning {
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  &.animated {
    animation-name: shake;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: shake;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warning-text {
  font-size: $font-size-l1;
  font-weight: 600;
  margin-left: 12px;
  color: #6e6e6e;
}
.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 0;
  left: 10px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
.tick {
  position: absolute;
  bottom: 21px;
  left: 17px;
  width: 45px;
  height: 45px;
  opacity: 0;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.7s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
@keyframes showPopup {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showc {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showt {
  0% { opacity: 1; transform: scale(0.2);}
  80% { transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}
.img-msg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  animation-delay: 0.4s;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
}
@keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
@-webkit-keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
.popup-btns {
  margin-left: auto;
  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }

}
.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}
@-webkit-keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}

@keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}
}
@-webkit-keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}

}
.top-bar {
  height: 64px;
  // width: 100%;
  width: 453px;
  transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
  
}

.heading_new {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}

.badget-custom-popup-title {
  transform: translate(140px, -24px);
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

// ESS UI part CSS
.income-tax-summary-box  {
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 1px 2px #f0f0f0;
}

.income-tax-text {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #5a5a5a;
  margin-left: 8px;
  font-family: 'Montserrat';
}

.col-10-new {
  
}

.back-btn-color-text {
  color: #40C6BF;
  font-weight: 600;
  text-align: center;
  margin: 12px 0px 0px;
  cursor: pointer;
}

.custom-col-3 {
  background: white;
  padding: 16px;
  width: 25%; // 24% change to 22%
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap:20px;
}

.sm-text-it-summary {
  color: #8d8d8d;
  font-size: 1.0rem;
  font-weight: 500;
  font-family: 'Montserrat';
}

.sm-sub-text-it-summary {
  font-weight: 600;
  margin-top: 8px;
  color: #5a5a5a;
  font-family: 'Montserrat';
}

.sm-sub-text-right {
  font-family: 'Montserrat';
  font-size: 0.8rem;
}

// .add-btn-sm {
//   margin-top: 5px;
// }

.change-btn-color-text {
  border: #34C0BD solid 1px;
  background: #34C0BD;
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  min-width: 180px;
  min-height: 30px;
  text-align: center;
  padding: 10px;
  margin-top: 6px;
  cursor: pointer;
}
.change-btn-color-text-save {
  border: #34C0BD solid 1px;
  background: #34C0BD;
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  min-width: 180px;
  min-height: 30px;
  max-height: 40px;
  text-align: center;
  padding: 10px;
  padding-left: 30px;
  margin-top: 34px;
  cursor: pointer;
}
.col-bg-gray {
  background: #ebebeb;
  padding: 15px;
  border-radius: 8px;
}

.img-block {
  margin-top: 6px;
}

.heading-text {
  font-size: 1.125rem;
  font-weight: bold;
  color: #40C6BF;
  margin-bottom: 9px;
  font-family: 'Montserrat';
}

.sub-heading-details-sm {
  color: #8d8d8d;
  line-height: 1.5rem;
  font-weight: 500;
  font-size: 1.1rem;
  font-family: 'Montserrat';
}

.total-amount-text {
  font-weight: bold;
  font-size: 1rem;
  margin-top: 14px;
  color: #5a5a5a;
  font-family: 'Montserrat';
}

.arrow-icon-it {
  position: relative;
  top: calc(50% - 10px);
}

.arrow-left-align {
  text-align: end;
  cursor: pointer;
}

.cursor-point {
  cursor: pointer;
}

.submitNote{
  color: red;
  font-size: 1.5rem;
  font-weight: 600;
}

.loadingDiv{
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 70vh;
  align-items: center;
}

.bg-gray {
  background-color: #f2f2f2;
  padding: 10px 20px;
  height: 60px;
  margin: 20px 0;
}

.warning-img {
  height: 25px;
  width: 25px;
  margin-right: 15px;
  transform: translate(5px, 5px);
}

.investment-alert-message {
  font-size: 14px;
  font-weight: 600;
}

.loading {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #376cd3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.tableheading{
  background-color: #f5f6fa;
            border-bottom: 1px solid #34c0be;
            height:54px;
            text-align:justify;
            th{
            padding: 6px 8px;

          }
}
.tableData{
  border-bottom: 1px solid #d8d8d8;
  tr{
    height: 54px;
    td{
      padding: 6px 8px;
      color: #646464;
      font-weight: 500;
    }
  }
   tr:nth-child(even){
    background-color: #f5f6fa;
   }
}
.radioButton{
  display: flex;
}
.no-wrap-label {
  white-space: nowrap;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
